module.exports = __webpack_public_path__ + "1ec9bdb6dfdb98048ce57c88562de4ee.png";